import { render } from "./editSliderHeroPaper.vue?vue&type=template&id=53edc7c6"
import script from "./editSliderHeroPaper.vue?vue&type=script&lang=js"
export * from "./editSliderHeroPaper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__